import React, {Component} from 'react';
import {Button, Modal, Table, Popup, Form} from 'semantic-ui-react';

import Loading from "../extras/Loading";
import ProductStockData from "../../data/ProductStockData";
import ProductStockUpdate from "./ProductStockUpdate";
import {connect} from "react-redux";
import {openModalProductStock} from "../../actions/ModalProductStockActions";
import {listProductStock, updateProductStock} from "../../actions/ProductStockActions";
import {openModalProductStockUpdate} from "../../actions/ModalProductStockUpdateActions";
import BranchOfficeData from "../../data/BranchOfficeData";
import update from "react-addons-update";
import {showToast} from "../../actions/ToastAction";
import {selectProduct} from "../../actions/ProductSelectActions";

class CurrentStockModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            header: ['Sucursal', 'Unidades Disponibles', 'Acciones'],
            id: null,
            branch_offices: [],
            selected_branch: 'warehouse',
            product:null,
            move_stock:{
                to:null,
                from: null,
                quantity: 1,
                stock_id:null,
                observations: ''
            },
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.product_stock_modal.id && this.state.id === null){
            this.setState({product: nextProps.product_stock_modal.id})
            ProductStockData.listByProduct(nextProps.product_stock_modal.id).then((data)=>{
                this.props.listProductStock(data);
                this.setState({loading:false, id:nextProps.product_stock_modal.id});
            });
            BranchOfficeData.listAll().then(branch_offices =>{
                branch_offices.unshift({key:'warehouse', value:'warehouse', text:'Bodega'})
                this.setState({branch_offices});
                this.handleStockMoveChange('warehouse', 'to')
            });
        }
    }

    handleClose = () => {
        this.setState({loading:true, id:null});
        this.props.openModalProductStock({id:null, name:null, is_open:false});
    };

    handleStockMoveChange = (result, key) => {
        let quantity = update(this.state, {
            move_stock: {
                [key]:  {$set: result}
            }
        });
        this.setState(quantity);
    };

    updateDialog = (stock, is_add) => {
        this.props.openModalProductStockUpdate({
            is_open: true,
            is_add,
            product:{
                name: this.props.product_stock_modal.name,
                id: this.props.product_stock_modal.id,
            },
            stock,
        });
    };

    trackStockModal = (branch_office) => {
        this.props.openModalProductStockTrack({
            is_open: true,
            product: this.props.product_stock_modal.id,
            product_name: this.props.product_stock_modal.name,
            branch_office,
        });
    };

    handleCloseModalUpdateStock = () => {
        this.setState({modal_move_stock: false, move_stock:{quantity: 1, observations: '', to:'warehouse'},})
    }

    handleMoveStockSubmit = () =>{
        this.setState({loading_stock:true});
        let data = this.state.move_stock
        data.from = this.state.branch_offices.find(branch => branch.text === this.state.selected_branch).key
        data.product = this.state.product
        ProductStockData.move(data, (res) => {
            if (res.update) {
                this.props.products_stock.find(stock => stock.id === data.from).total -= data.quantity
                if(data.to === 'warehouse'){
                    let product = {}
                    Object.assign(product, this.props.product_select);
                    product.count_stock -= data.quantity
                    this.props.selectProduct(product);
                }else{
                    this.props.products_stock.find(stock => stock.id === data.to).total += data.quantity
                }
                this.props.showToast({message: 'Inventario Actualizado!', type: 'success'});
                this.handleCloseModalUpdateStock()
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({loading_stock:false});
        });
    }

    render() {
        let rows = this.props.products_stock.map(stock => {
            return (
                <Table.Row
                    key={stock.id}
                    negative={stock.total <= 5 }
                    warning={stock.total > 5 && stock.total <= 10}
                >
                    <Table.Cell>{stock.name}</Table.Cell>
                    <Table.Cell>{stock.total}</Table.Cell>
                    <Table.Cell>
                        <Button.Group basic size='small'>
                            <Popup
                                trigger={<Button icon='plus' onClick={() => this.updateDialog(stock, true)}/>}
                                content='Agregar al Inventario'
                                size='small'
                            />
                            <Popup
                                trigger={<Button icon='remove' onClick={() => this.updateDialog(stock, false)}/>}
                                content='Quitar del Inventario'
                                size='small'
                            />
                            <Popup
                                trigger={
                                    <Button
                                        icon='refresh'
                                        onClick={
                                            () => this.setState({modal_move_stock:true, selected_branch:stock.name, stock_id:stock.id})
                                        }
                                    />
                                }
                                content='Mover Inventario'
                                size='small'
                            />
                        </Button.Group>
                    </Table.Cell>
                </Table.Row>
            )
        }, this);

        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.product_stock_modal.is_open} onClose={this.handleClose}>
                    <Modal.Header>{`${this.props.product_stock_modal.name} - Inventario`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            {this.state.loading ? <div style={{height:50}}><Loading/></div> : null}
                            {this.state.loading ? null :
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>{
                                            this.state.header.map(function (header, i) {
                                                return (
                                                    <Table.HeaderCell key={i}>
                                                        {header}
                                                    </Table.HeaderCell>
                                                )
                                            })
                                        }</Table.Row>
                                    </Table.Header>
                                    <Table.Body>{rows}</Table.Body>
                                </Table>
                            }
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
                <ProductStockUpdate />
                <Modal open={this.state.modal_move_stock} dimmer='inverted' size='tiny' onClose={this.handleCloseModalUpdateStock}>
                    <Modal.Header>Mover Inventario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleMoveStockSubmit}>
                                <Form.Dropdown
                                    label={'Mover a'}
                                    options={this.state.branch_offices.filter(branch => branch.text !== this.state.selected_branch)}
                                    value={this.state.move_stock.to}
                                    compact
                                    selection
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'to')}
                                    placeholder='Mover a'
                                />
                                <Form.Input
                                    label='Cantidad'
                                    placeholder='Cantidad'
                                    type='number'
                                    name='quantity'
                                    min={0}
                                    step={'.01'}
                                    value={this.state.move_stock.quantity}
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'quantity')}
                                    error={this.state.move_stock_quantity_error}
                                />
                                <Form.TextArea
                                    label='Observaciones'
                                    placeholder='Observaciones'
                                    value={this.state.move_stock.observations}
                                    onChange={(e, {value}) => this.handleStockMoveChange(value, 'observations')}
                                />
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleCloseModalUpdateStock} content="Cerrar"/>
                        <Button primary icon='save'
                                labelPosition='left'
                                onClick={this.handleMoveStockSubmit}
                                disabled={this.state.moving_stock}
                                loading={this.state.moving_stock}
                                content='Mover'/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        product_stock_modal: state.get('product_stock_modal'),
        products_stock: state.get('products_stock'),
        product_select: state.get('product_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalProductStock(modal){
            dispatch(openModalProductStock(modal))
        },
        listProductStock(products_stock){
            dispatch(listProductStock(products_stock))
        },
        openModalProductStockUpdate(modal){
            dispatch(openModalProductStockUpdate(modal))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectProduct(data){
            dispatch(selectProduct(data))
        },
        updateProductStock(product_stock){
            dispatch(updateProductStock(product_stock))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CurrentStockModal);



// WEBPACK FOOTER //
// ./src/components/inventories/CurrentStockModal.js